import { useEffect, useState } from "react";
import DateTimeDisplay from "./DateTimeDisplay";

export const UseCountdown = ({ targetDate }) => {
  const countDownDate = new Date(targetDate).getTime();

  const [countDown, setCountDown] = useState(countDownDate - new Date().getTime());
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  return (
    <span className="show-counter">
      {days > 0 && (
        <>
          <DateTimeDisplay value={days} type={"Days"} isDanger={false} />
          <span className="dot">:</span>
        </>
      )}
      <DateTimeDisplay value={hours} type={"Hours"} isDanger={false} />
      <span className="dot">:</span>
      <DateTimeDisplay value={minutes} type={"Mins"} isDanger={false} />
      <span className="dot">:</span>
      <DateTimeDisplay value={seconds} type={"Seconds"} isDanger={days === 0 && hours === 0 && minutes === 0 && seconds < 15} />
    </span>
  );
};
